module.exports = __webpack_public_path__ + "img/Carrousels STARTO – après rdv_slide_5.6a04adc3.png";